const CaseStatusType = {
  Cancelled: 'Cancelled',
  Closed: 'Closed',
  Open: 'Open',
  Pending: 'Pending',
};

export default CaseStatusType;
